<template>
    <div class="filter-popup" v-bind:style="{display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        
        <div style="border-bottom:1px solid #e5e5e5;">
            <div style="color: #6d8d23; font-size: 18px; font-family: DistrictProBold; padding-bottom: 7px;">
                {{ $t('roster.comp.filter') }}
            </div>
        </div>

        <div style="font-family: DistrictProLight; font-size: 12px;">
            <!-- DYNAMISCHER FILTER -->
            <div style="padding-top: 15px; padding-bottom: 15px;">
                <div v-if="$parent.dynamicFiltering" class="dynFilterGreen" style="text-align:center;" v-on:click="ToggleDynamicFilter()">
                    <div style="display:inline-block; text-align:center;">{{ $t('roster.comp.deactivateDynamicFilter') }}</div>
                </div>
                <div v-if="!$parent.dynamicFiltering" class="dynFilterGray" style="text-align:center;" v-on:click="ToggleDynamicFilter()">
                    <div style="display:inline-block; text-align:center;">{{ $t('roster.comp.activateDynamicFilter') }}</div>
                </div>
            </div>
            
            <!-- DYNAMISCHER FILTER ENDE -->






            <div style="border-top:1px solid #e5e5e5; border-bottom:1px solid #e5e5e5; padding-top:10px; padding-bottom: 10px;">
                <div class="buWhite" v-on:click="ToggleSortByContract()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.sortByWeeklyHours') }}</div>
                    <div v-if="employeeSortState.sortByContractType" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>
                <div class="buWhite" v-on:click="ToggleSortByEmployeePriority()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.sortByPriority') }}</div>
                    <div v-if="employeeSortState.sortByPriority" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>
                
                
                <div class="buWhite" v-on:click="ToggleBusinessUnits()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.groupByUnit') }}</div>
                    <div v-if="rosterSortState.showBusinessUnits" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>

                <div class="buWhite" v-on:click="ToggleSpots()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.groupByPosition') }}</div>
                    <div v-if="rosterSortState.showSpots" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>

                <!-- only show group by shift spots in dayMode for now
                - could be an issue with employees having shifts in different spots
                - same could happen on a single day though -> duplicate entries? -->
                <div class="buWhite" v-if="$parent.dayMode" v-on:click="ToggleShiftSpots()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.groupByShiftPosition') }}</div>
                    <div v-if="rosterSortState.showShiftSpots" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>

                <div class="buWhite" v-on:click="ToggleFilterByShiftSpot()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.filterByPositionAndSkill') }}</div>
                    <div v-if="rosterSortState.filterByShiftSpot" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>

                <div class="buWhite" v-on:click="ToggleFilterByOnlyShiftSpot()" v-if="rosterSortState.filterByShiftSpot">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.onlyShowWithShift') }}</div>
                    <div v-if="rosterSortState.filterByOnlyShiftSpot" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
                </div>
               
            </div>

            <div v-if="rosterSortState.showBusinessUnits || rosterSortState.showSpots || rosterSortState.filterByShiftSpot" style="padding-top: 15px;">
                <div style="padding-top: 15px; padding-bottom: 15px;">
                    <div v-bind:class="{dynFilterGreen: toggleAll, dynFilterGray: !toggleAll}" style="text-align:center;" v-on:click="toggleAllGroups()">
                        <div style="display:inline-block; text-align:center;">{{ $t('global.ui.all') }}</div>
                    </div>
                </div>
                <!-- Tier 1 loop -->
                <div v-for="(group0, id0) in spotGroups" :key="id0">
                    <div :class="group0.toggled ? 'buBackgroundGreen' : 'buBackgroundGray'" v-on:click="toggleGroup(group0)" style="margin-bottom: 5px;">
                        <div v-if="group0.toggled" style="float:right;"><i class="fas fa-check-circle"></i></div>
                        <div v-else style="float:right;"><i class="fas fa-circle" style="color:#fff;"></i></div>
                        <div style="display:inline-block; padding-left: 7px;">{{ group0.label }}</div>
                    </div>
                </div>
            </div>

        </div>



    </div>
</template>


<script>
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'filterpopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                rawData: null,
                softSkillsFiltered: [],
                toggleAll: false,
                spots: [],
            }
        },
        created () {
            var view = this;
        },
        destroyed(){
        },
        computed: {
            ...mapGetters([
                'employeeSortState', 'rosterSortState'
            ]),
            spotGroups() {
                let view = this;
                const displayedSpots = view.$parent.displayedSpots;
                let sortedSpots = view.$parent.sortedSpotGroups;
                return sortedSpots.filter(spot => view.rosterSortState.showBusinessUnits ? spot.isMain : true).map(spot =>  {return {id: spot.id, label: spot.label, toggled: displayedSpots.includes(spot.id)}});
            }
        },
        methods: {
            Close(){
                //if($(window.mouse.element).closest('.filter-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(){
                
                this.toggled = true;
            },
            InitData(){
                var view = this;
            },
            ToggleFilterByShiftSpot(){
                this.rosterSortState.showSpots = false;
                this.rosterSortState.showBusinessUnits = false;
                this.rosterSortState.filterByShiftSpot =  !this.rosterSortState.filterByShiftSpot;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups();
                this.$parent.RefreshRosterContentMap();
            },
            ToggleFilterByOnlyShiftSpot(){
                this.rosterSortState.filterByOnlyShiftSpot =  !this.rosterSortState.filterByOnlyShiftSpot;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups();
                this.$parent.RefreshRosterContentMap();
            },
            ToggleBusinessUnits(){
                this.rosterSortState.filterByShiftSpot = false;
                this.rosterSortState.showSpots = false;
                this.rosterSortState.showShiftSpots = false;
                this.rosterSortState.showSpotPlanningNumbersSwitch = false;
                this.rosterSortState.showBusinessUnits = !this.rosterSortState.showBusinessUnits;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups();
                this.$parent.RefreshRosterContentMap();
            },
            ToggleSpots(){
                this.rosterSortState.filterByShiftSpot = false;
                this.rosterSortState.showBusinessUnits = false;
                this.rosterSortState.showShiftSpots = false;
                this.rosterSortState.showSpotPlanningNumbersSwitch = false;
                this.rosterSortState.showSpots = !this.rosterSortState.showSpots;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups();
                this.$parent.RefreshRosterContentMap();
            },
            ToggleShiftSpots(){
                this.rosterSortState.filterByShiftSpot = false;
                this.rosterSortState.showBusinessUnits = false;
                this.rosterSortState.showSpots = false;
                this.rosterSortState.showShiftSpots = !this.rosterSortState.showShiftSpots;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups();
                this.$parent.RefreshRosterContentMap();
            },
            ToggleDynamicFilter(){
                this.$parent.dynamicFiltering = !this.$parent.dynamicFiltering;
                this.$parent.filterEmployees();
            },
            ToggleSortByContract(){
               
                this.$store.commit('setEmployeeSortStateToggle', 'sortByContractType');
                
                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups(); 
            },
            ToggleSortByEmployeePriority(){
               
                this.$store.commit('setEmployeeSortStateToggle', 'sortByPriority');
                
                this.$parent.updateSpots();
                this.$parent.sortEmployeeGroups(); 
            },
            ToggleSkill($event, skillId, id, idmap){
                if(id != null) this.$parent.softSkills[id].toggled = !this.$parent.softSkills[id].toggled;
                if(idmap != null) this.$parent.spotMap[idmap].toggled = !this.$parent.spotMap[idmap].toggled;

                let index = this.$parent.softSkillsFiltered.indexOf(skillId);
                if (index !== -1){
                    this.$parent.softSkillsFiltered.splice(index, 1);
                }else{
                    this.$parent.softSkillsFiltered.push(skillId);
                }
                this.$parent.filterEmployees();
                this.$forceUpdate();
            },
            toggleGroup(group){
                let res = [];
                let newToggle = !group.toggled;
                if(newToggle){
                    res = this.spotGroups.filter(g => g.toggled).map(g => g.id);
                    res.push(group.id);
                } else {
                    res = this.spotGroups.filter(g => g.toggled && g.id != group.id).map(g => g.id);
                }
                this.$parent.updateDisplayedSpots(res);
                this.$parent.LoadAssignedShiftSpotListToolTipMap();
                this.$forceUpdate();
            },
            toggleAllGroups(){
               
                this.toggleAll = !this.toggleAll;
                let res = [];
                if(this.toggleAll) {
                    res = this.spotGroups.map(g => g.id)
                }
                this.$parent.updateDisplayedSpots(res);
                this.$parent.LoadAssignedShiftSpotListToolTipMap();
            },
           

        },
        
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .dynFilterGray{
        background-color: #e5e5e5; 
        padding:7px 10px; 
        border-radius: 0px;
        border:solid 1px #777;

        color: #111; 
        cursor:pointer; 

        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }
    .dynFilterGreen{
        background-color: #6d8d23; 
        padding:7px 10px; 
        border-radius: 0px;
        border:solid 1px #777;

        color: #fff; 
        cursor:pointer; 

        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }



    .buBackgroundGreen{
        background-color: #6d8d23; 
        padding:5px 10px; 
        border-radius: 0px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
        font-weight: 800;
    }
    .buBackgroundGray{
        background-color: #ccc; 
        padding:5px 10px; 
        border-radius: 0px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
        font-weight: 800;
    }
    
    .spotBackgroudGreen{
        margin-left: 35px;
        background-color: #6d8d23; 
        padding:5px 10px; 
        border-radius: 0px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 1000ms linear;
        transition: color 1000ms linear;
    }
    .spotBackgroudGray{
        margin-left: 35px;
        background-color: #ccc; 
        padding:5px 10px; 
        border-radius: 0px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 1000ms linear;
        transition: color 1000ms linear;
        font-weight: 800;
    }



    .buWhite{
        background-color: #fff; 
        padding:4px 0px; 
        border-radius: 0px; 
        color: #333; 
        cursor:pointer;
    }

    .filter-popup{
        position:fixed;
        display:inline-block;
        max-height: 770px;
        width: 400px;
        border-radius: 0px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 25px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .header{
        margin-bottom:45px;
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 20px;
    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

</style>
